import client from "/src/services/client.js";

export default {
    askQuestion: (chatId, brainId, question) =>
        client.post(`rag/chat/${chatId}/question/stream?brain_id=${brainId}`, { brain_id: brainId, question }),
    getChatHistory: (id) => client.get(`rag/chat/${id}/history`),
    getChats: () => client.get(`rag/chat`),
    createChat: () => client.post("rag/chat", { name: "New Chat" }),
    deleteChat: (id) => client.delete(`rag/chat/${id}`),
};
